import React from 'react';
import './map-sec.css'
import { supabase } from '../supabase';
import { useState } from 'react';
import { useEffect} from 'react';
import "leaflet/dist/leaflet.css";
import Mapcomponent from '../components/common/map';
import Cta from '../components/common/cta';
import SecCta from '../components/common/secondarycta';


const Mapsec = () => {



 const [content, setcontent]= useState([]);
      useEffect(() => {
      const getcontent = async()=>{
          const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;;
    
      setcontent(res.data);
      }
      getcontent();
      }, []);


 const [location, setlocation]= useState([]);


 useEffect(() => {
  const getlocation = async () => {
    const { data, error } = await supabase
      .from('exbition_event')
      .select('*')
      .order('id', { ascending: true });

    console.log("LOCATION DATA:", data); 

    if (error) console.error(error);
    else setlocation(data);
  };

  getlocation();
}, []);





    return ( 
        <section className='map-sec'>
            <section className='map-container-sec'>
                    <h1 className='header-map-section '>{content?.[27]?.header}</h1>
                    <section className='container-map-box'>
                        <nav className='container-cta-map'>
                            <button className='button-containerr-map'>
                                <Cta title={content?.[27]?.cta}/>
                               
                            </button>
                              <button className='button-containerr-map'>
                             <SecCta title={content?.[27]?.cta2} />
                             </button>
                        </nav>
                        <Mapcomponent lat={location?.[0]?.lat} lng={location?.[0]?.lng} />
                    </section>
            </section>
        </section>
     );
}
 
export default Mapsec;